// src/App.js
import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate
} from "react-router-dom";

import Header          from "./components/Header";
import Login           from "./components/Login";
import Home            from "./components/Home";
import BCList          from "./components/BCList";
import PendingBC       from "./components/PendingBC";
import VarianceMatch   from "./components/VarianceMatch";
import VarianceUnmatch from "./components/VarianceUnmatch";
import ResetPassword   from "./components/ResetPassword";
import BeritaAcara     from "./components/BeritaAcara";

// --- helpers ---
function safeLoadUser() {
  try {
    const raw = localStorage.getItem("trakiebc_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    localStorage.removeItem("trakiebc_user");
    return null;
  }
}

function RequireAuth({ user, children }) {
  const location = useLocation();
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

// Wrap Login so it redirects back to intended path after success
function LoginWithRedirect({ onLogin }) {
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from?.pathname || "/";

  return (
    <Login
      onLogin={(u) => {
        onLogin(u);
        navigate(from, { replace: true });
      }}
    />
  );
}

export default function App() {
  const [user, setUser] = useState(() => safeLoadUser());

  useEffect(() => {
    if (user) localStorage.setItem("trakiebc_user", JSON.stringify(user));
    else localStorage.removeItem("trakiebc_user");
  }, [user]);

  // If you ever host under a sub-path, set REACT_APP_BASENAME at build time.
  const basename = process.env.REACT_APP_BASENAME || "/";

  return (
    <BrowserRouter basename={basename}>
      {user && <Header user={user} onLogout={() => setUser(null)} />}
      <Routes>
        <Route
          path="/login"
          element={
            user ? <Navigate to="/" replace /> : <LoginWithRedirect onLogin={setUser} />
          }
        />
        <Route
          path="/"
          element={
            <RequireAuth user={user}>
              <Home />
            </RequireAuth>
          }
        />
        <Route
          path="/bc-list"
          element={
            <RequireAuth user={user}>
              <BCList />
            </RequireAuth>
          }
        />
        <Route
          path="/pending-bc"
          element={
            <RequireAuth user={user}>
              <PendingBC />
            </RequireAuth>
          }
        />
        <Route
          path="/variance-match"
          element={
            <RequireAuth user={user}>
              <VarianceMatch />
            </RequireAuth>
          }
        />
        <Route
          path="/variance-unmatch"
          element={
            <RequireAuth user={user}>
              <VarianceUnmatch />
            </RequireAuth>
          }
        />
        <Route
          path="/berita-acara"
          element={
            <RequireAuth user={user}>
              <BeritaAcara />
            </RequireAuth>
          }
        />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
